import { render, staticRenderFns } from "./WidgetChatsSent.vue?vue&type=template&id=8438a8f0&scoped=true&"
import script from "./WidgetChatsSent.vue?vue&type=script&lang=js&"
export * from "./WidgetChatsSent.vue?vue&type=script&lang=js&"
import style0 from "./WidgetChatsSent.vue?vue&type=style&index=0&id=8438a8f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8438a8f0",
  null
  
)

export default component.exports